module.exports = __webpack_public_path__ + "resources/img/img_nginx_m_en.440283aeaffdb3cafe7fe559ba1d7aea.png";